<div class="container">
  <div class="close-btn">
    <mat-icon mat-dialog-close>close</mat-icon>
  </div>
  <div class="popup-title" *ngIf="projectTitle">
    {{ projectTitle }}
  </div>
  <div class="table-shell" *ngIf="isAuditHistoryLayout">
    <ngx-datatable
      class="material audit-history-table"
      [rows]="rows?.[0]?.records || rows"
      [columnMode]="columnMode"
      [headerHeight]="30"
      [footerHeight]="50"
      [rowHeight]="42"
      [scrollbarH]="true"
      [limit]="18"
    >
      <ng-container *ngFor="let header of data.headers">
        <ngx-datatable-column
          [name]="header.label"
          [prop]="header.key"
          [width]="header.width || 180"
        >
        </ngx-datatable-column>
      </ng-container>
    </ngx-datatable>
  </div>

  <ngx-datatable *ngIf="!isAuditHistoryLayout"
    class="material"
    [rows]="rows?.[0]?.records || rows"
    [columnMode]="columnMode"
    [headerHeight]="30"
    [footerHeight]="20"
    rowHeight="auto"
    [scrollbarH]="true"
  >
    <ng-container *ngFor="let header of data.headers">
      <ngx-datatable-column
        [name]="header.label"
        [prop]="header.key"
        [width]="header.width || 180"
      >
      </ngx-datatable-column>
    </ng-container>
  </ngx-datatable>

  <!-- Spinner overlay -->
  <div class="spinner-overlay" *ngIf="isLoading">
    <mat-progress-spinner
      mode="indeterminate"
      diameter="40"
    ></mat-progress-spinner>
  </div>

</div>
<!-- </div> -->
